import styled from "styled-components";
export const Indent = styled.div `
    margin-left: ${props => props.$margin_left || "4px"};
    height: ${props => props.$height || "100%"};
`;
